<template>
    <div v-if="active" class="birthday-confetti-container">
        <!-- 20 Glitter & Micro-confetti Particles -->
        <span class="particle glitter p1 size-sm"></span>
        <span class="particle confetti p2 size-md"></span>
        <span class="particle glitter p3 size-lg"></span>
        <span class="particle confetti p4 size-sm"></span>
        <span class="particle glitter p5 size-md"></span>
        <span class="particle confetti p6 size-lg"></span>
        <span class="particle glitter p7 size-sm"></span>
        <span class="particle confetti p8 size-md"></span>
        <span class="particle glitter p9 size-lg"></span>
        <span class="particle confetti p10 size-sm"></span>
        <span class="particle glitter p11 size-md"></span>
        <span class="particle confetti p12 size-lg"></span>
        <span class="particle glitter p13 size-sm"></span>
        <span class="particle confetti p14 size-md"></span>
        <span class="particle glitter p15 size-lg"></span>
        <span class="particle confetti p16 size-sm"></span>
        <span class="particle glitter p17 size-md"></span>
        <span class="particle confetti p18 size-lg"></span>
        <span class="particle glitter p19 size-sm"></span>
        <span class="particle confetti p20 size-md"></span>
    </div>
</template>

<script>
export default {
    name: 'BirthdayCelebration',
    data() {
        return {
        active: true
        }
    },
    mounted() {
        // Gracefully unmount and remove from DOM after the 5s loop completes
        setTimeout(() => {
            this.active = false;
        }, 5500);
    }
}
</script>

<style scoped>
.birthday-confetti-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none; /* Safe click-throughs for sign-in buttons */
    z-index: 10;
}

/* Base Particle Properties */
.particle {
    position: absolute;
    top: -20px;
    opacity: 0;
    animation: fallAndFlutter 5s ease-out forwards;
}

/* Multi-Dimensional Sizing Classes */
.size-sm { width: 4px; height: 8px; border-radius: 1px; }
.size-md { width: 6px; height: 12px; border-radius: 2px; }
.size-lg { width: 8px; height: 10px; border-radius: 50%; } /* Round discs mix up the shapes */

/* ✨ Type 1: High-Shine Metallic Glitter */
.glitter {
    box-shadow: 0 0 6px rgba(255, 215, 0, 0.8), 0 0 2px rgba(255, 255, 255, 0.9);
}
/* 🎨 Type 2: Standard Clean Pastel Confetti Blocks */
.confetti {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Dynamic Positioning, Timing, and Brand-Safe Accents */
.p1, .p11 { background-color: #FFD700; left: 8%;  animation-delay: 0.1s; } /* Gold Glitter */
.p2, .p12 { background-color: #FF8A8A; left: 18%; animation-delay: 0.8s; }
.p3, .p13 { background-color: #FFFFFF; left: 27%; animation-delay: 0.3s; } /* Silver Sparkle */
.p4, .p14 { background-color: #90E0EF; left: 36%; animation-delay: 1.2s; }
.p5, .p15 { background-color: #FFD384; left: 45%; animation-delay: 0.2s; }
.p6, .p16 { background-color: #FFD700; left: 54%; animation-delay: 0.9s; } /* Gold Glitter */
.p7, .p17 { background-color: #A8E6CF; left: 65%; animation-delay: 0.5s; }
.p8, .p18 { background-color: #E19999; left: 74%; animation-delay: 1.5s; }
.p9, .p19 { background-color: #FFFFFF; left: 83%; animation-delay: 0.4s; } /* Silver Sparkle */
.p10, .p20{ background-color: #DED9C4; left: 92%; animation-delay: 1.0s; }

/* Dynamic Speed Variance */
.p11, .p12, .p13, .p14, .p15, .p16, .p17, .p18, .p19, .p20 {
    animation-duration: 4.2s; /* Creates an asymmetrical layer effect */
}

@keyframes fallAndFlutter {
    0% {
        top: -20px;
        opacity: 0;
        transform: translateX(0) rotate(0deg) scale(1);
    }
    8% {
        opacity: 1; /* Quickly achieve full opacity near the top */
    }
    50% {
        transform: translateX(15px) rotate(270deg) scale(1.1);
    }
    90% {
        opacity: 1; /* 🔥 Keep them fully visible and bright for 90% of the drop */
    }
    100% {
        top: 95%;   /* Clean finish right at the card threshold */
        opacity: 0; /* Gently dissolve only at the very end */
        transform: translateX(-15px) rotate(720deg) scale(0.8);
    }
}
</style>
